import AsyncRoute from '../components/AsyncContainer/AsyncContainer'

// Dashboard routes
export const Dashboard = AsyncRoute(() =>
  import('../components/Pages/Dashboard/Dashboard')
)
